module.exports = __webpack_public_path__ + "img/lobby_bar.08e86324.jpg";